
import { Grid } from "@mui/material";
// import { ShowBase, useResourceContext } from "ra-core";
import { FC } from "react";
// import PullImageCard from "@/components/settings/secureai/PullImageCard";
import RegistrationCard from "@/components/settings/secureai/RegistrationCard";



const rcodeResource_s = 'settings-secureai-app-register-code'
const rcodeResource_d = 'settings-secureai-mcpservers-register-code'

const SecureAIAppDataSourceRegistratonCode: FC = () => {
  // const resource = useResourceContext()

  return (
    <Grid container spacing={6}>
      {/* <Grid item xs={12}>
        <ShowBase resource={resource} id="info" basePath="">
          <PullImageCard productName="MCP Server" imageName="ondata-secureai-mcpserver"/>
        </ShowBase>
      </Grid> */}

      <Grid item xs={12}>
        <RegistrationCard headerTitle="SecureAI App Registration Code" resource={rcodeResource_s} />
      </Grid>
      <Grid item xs={12}>
        <RegistrationCard headerTitle="Data Source Registration Code" resource={rcodeResource_d} />
      </Grid>
    </Grid>
  )
}

export default SecureAIAppDataSourceRegistratonCode;
